import fadeinGutenbergBlocksObserver from "./fadeInGutenbergBlocks";
declare var hljs: any;

/**
 * File main.js.
 */

(function () {
  const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const darkModeEvent = new Event('changed-dark-mode');
  const darkModeToggle = document.getElementById('darkmode-switch__toggle-checkbox') as HTMLInputElement | null;

  if (darkModeToggle) {
    darkModeToggle.checked = darkMode;
    darkModeToggle.addEventListener("change", addActivityItem, {passive: false});
  }

  if (window.sessionStorage) {
    const sessionDarkModeKey = 'DarkMode';
    const sessionDarkMode = JSON.parse(sessionStorage.getItem(sessionDarkModeKey));

    if (!(sessionDarkMode === null)) {
      // sessionStorage supported
      // sessionStorage.setItem(sessionDarkModeKey, darkMode);
      darkModeToggle.checked = sessionDarkMode;
      setDarkModeClass(sessionDarkMode);
    } else {
      sessionStorage.setItem(sessionDarkModeKey, String(darkMode));
      window.dispatchEvent(darkModeEvent);
    }
  }

  function addActivityItem() {
    let darkMode = this.checked;

    sessionStorage.setItem('DarkMode', JSON.stringify(darkMode));
    setDarkModeClass(darkMode);
    window.dispatchEvent(darkModeEvent);
  }

  function setDarkModeClass(darkMode : boolean) {

    if (darkMode) {
      document.documentElement.classList.remove('user-light-mode');
      document.documentElement.classList.add('user-dark-mode');
    } else {
      document.documentElement.classList.remove('user-dark-mode');
      document.documentElement.classList.add('user-light-mode');
    }
  }

  const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

  if ( ! reduceMotion ) {
    window.addEventListener('DOMContentLoaded', (event) => {
      const elementsToFadeIn = document.querySelectorAll(".crftd-fade-group");

      elementsToFadeIn.forEach(el => {
        fadeinGutenbergBlocksObserver.observe(el);
      })

    });
  }

  if (typeof hljs !== 'undefined') {
    hljs.initHighlightingOnLoad();
  }

})();
